<template>
  <div class="company-event-list-item">
    <div class="row company-event-list-item-content">
      <div class="company-event-list-item-time">{{data.time}}</div>
      <div>{{data.count}}条相关新闻</div>
    </div>
    <router-link class="company-event-list-item-title" target="_blank" :to="{path: '/event-detail', query:{title: data.title, id: data.id}}">
      <div>{{data.title}}</div>
    </router-link>
    <div class="symbol"></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    toEventDetailPage() {
      const routeUrl = this.$router.resolve({
        path: '/event-detail', 
        query: {
          title: this.data.title,
          id: this.data.id
        }  
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.company-event-list-item {
  position: relative;
  width: 100%;
  padding: 16px 20px;
  border-left: 2px solid #f7f7fa;
  &-content {
    padding-bottom: 8px;
    color: #747990;
    font-size: 12px;
  }
  &-time {
    margin-right: 16px;
  }
  &-title {
    color: #171f46;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .symbol {
    position: absolute;
    top: 20px;
    left: -5px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #45a8cc;
  }
}
</style>
